import React, { useState, useEffect } from "react";
import Stepper from "bs-stepper";
import "bs-stepper/dist/css/bs-stepper.min.css";
import StepperHeaderComponent from "./StepperHeaderComponent";
import StepDetailsComponent from "./StepDetailsComponent";
import GeneralDetailsComponent from "./GeneralDetailsComponent";
import CurrentApplicationForm from "./CurrentApplicationForm";
// import MetricsSubsequentComponent from "./MetricsSubsequentComponent";
// import MetricIncubatorComponent from "./MetricIncubatorComponent";


import SupportDetailsComponent from "./SupportDetailsComponent";
import TeamDetailsComponent from "./TeamDetailsComponent";
import FundDetailsComponent from "./FundDetailsComponent";
import OtherDetailsComponent from "./OtherDetailsComponent";
import FormSubmissionSuccess from "./FormSubmissionSuccess";
import { IIncubatorModel } from "./IncubatorModel";
import { GeneralDetailModel } from "../../../models/incubator/GeneralDetailModel";
import { IncubatorDetailsModel } from "../../../models/incubator/IncubatorDetailsModel";
import { requestType, StepperEnum, UploadTypeEnum } from "../../../utils/Enums";
import { SaveRequestModel } from "../../../models/incubator/SaveRequestModel";
import { post } from "../../../effects/api/api.common";
import {
  CREATE_EMPTY_APPLICATION,
  FILE_UPLOAD,
  GET_ACTIVE_APPLICATION,
  GET_RE_APPLICATION_VIEW,
  GET_STORE_INCUBATOR_DATA,
  STORE_INCUBATOR_APPLICATION,
} from "../../../constants/api";
import { FundDetailsModel } from "../../../models/incubator/FundDetailsModel";

import { IncubatorOthersModel } from "../../../models/incubator/IncubatorOthersModel";
import FormSubmissionError from "./FormSubmissionError";
import { FileUploadModel } from "../../../models/FileUploadModel";
import { createFile } from "../../../utils/CommonMethods";
import { Link } from "react-router-dom";
//import { isArray } from "node:util";
import ConfirmationDialog from "../../common/controls/ConfirmationDialog";
import { IQuestionModel } from "../../../models/eac/QuestionModel";
import { useHistory } from "react-router-dom";
import { ErrorModel } from "../../../models/common/ErrorModel";
import { GeneralIncubatorModel,TeamDetails } from "../../../models/incubator/GeneralIncubatorModel";
import { SaveIncubatorModel } from "../../../models/incubator/SaveIncubatorModel";
import { IIncubatorModel2 } from "./IncubatorModel2";
import { IncubatorSchemePartOne } from "../../../models/incubator/IncubatorSchemePartOne";
import { IncubatorSchemePartTwo } from "../../../models/incubator/IncubatorSchemePartTwo";
import { getSessionStorageValue } from "../../../effects/utils/session-storage";
import IncubatorHeaderComponent from "../common/IncubatorHeaderComponent";
import FundRequiremntDtls from "./FundRequiremntDtls";
import { FundReapplyDtlsModel } from "../../../models/incubator/FundReapplyDtlsModel";

interface IIncubatorProps {
  // incubator_application_no: number;
  location: any;
  disabled: boolean;
}

interface IIncubatorState {
  stepperRef: any;
  name: string;
  applicationId: number;
  incubator: IIncubatorModel2;
  showIncubatorSuccessModal: boolean;
  showIncubatorErrorModal: boolean;
  // not in use but helps to call re-render method to bind other tabs
  currentStep: number;
  viewApplicationId: number;
  disabled: boolean;
}

let stepper: any = null;
let isSubmitted: boolean = false;
let formError: any;

const ReApplyIncComponent = (props: IIncubatorProps) => {
  const [name, setName] = useState("React");
  const [Application_number, setApplication_number] = useState('');
  const history = useHistory();
  const [stepperRef, setStepperRef] = useState(null);
  const [applicationId, setApplicationId] = useState('0');
  const [significantfileuploadArray, setsignificantfileuploadArray] = useState('');
  const [fulltimeEmployeesArray, setfulltimeEmployeesArray] = useState('');
  const [pitchdeckArray,setPitchdeckArray] = useState('');
  const [performanceArray,setPerformanceArray] = useState('');
  const [otherdocArray,setOtherdocArray] = useState('');
  const [ucfilesArray, setucfilesArray] = useState('');
  const [AuditedfilesArray, setAuditedfilesArray] = useState('');
  const [CurrentUploadfilesArray, setCurrentUploadfilesArray] = useState('');
  const [loader, setLoader] = useState(false);
  const [incubator, setIncubator] = useState({
    GeneralDetail: new GeneralIncubatorModel(
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "", 
      "",
      [],
      ""
    ),
    // IncubatorTeam: new IncubatorSchemePartOne("", "", "", "", "", "", "", "", "", "","","","",""),
    // IncubatorDetails: new IncubatorSchemePartTwo(
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    //   "",
    // ),
    FundDetails: new FundReapplyDtlsModel("","", "", "",""),
    // OtherDetails: new IncubatorOthersModel(
    //   "",
    //   [],
    //   [],
    //   [],
    //   [],
    //   false,
    //   false,
    //   false,
    //   false,
    //   []
    // ),
  });
  const [showIncubatorSuccessModal, setShowIncubatorSuccessModal] = useState(
    false
  );
  const [showIncubatorErrorModal, setShowIncubatorErrorModal] = useState(false);
  const [currentStep, setCurrentStep] = useState(StepperEnum.GeneralDetail);

  const [disabled, setDisabled] = useState(false);
  const [validator, setValidator] = useState({
    GeneralDetail: [],
    // IncubatorTeam: [],
    // IncubatorDetails: [],
    FundDetails: [],
    // OtherDetails: [],
  });
  const [teamError, setTeamError] = useState<Array<number>>([]);
  const [stopSubmit, setStopSubmit] = useState(false);
  const [firstLoad, setFirstLoad] = useState(false);
  const [isfalse,setIsFalse] = useState(false)
  //
  useEffect(() => {
    ////console.log(props, "ppp");
    // ////console.log(incubator);
    ////console.log(applicationId, "applicationId");
    //console.log(typeof(incubator.GeneralDetail.team_data),"202")
    if (typeof props.location.state != "undefined") {
      // if (props.location.state.incubator_application_no == 0) {
      //   setApplicationId(0);
      // } else
      if (
        props.location.state.application_id != 0
        &&
        props.location.state.disabled == true
      ) {
        ////console.log("IF");
        setDisabled(true);
        setApplicationId(props.location.state.application_id);
        viewActiveApplication(props.location.state.application_id);
      } else if (
        props.location.state.application_id != 0 &&
        props.location.state.continue_editing == 1
      ) {
        ////console.log("ELSE_IF");
        // setDisabled(false);
        setApplicationId(props.location.state.application_id);
        viewActiveApplication(props.location.state.application_id);
        setValidator({
          GeneralDetail: [],
          // IncubatorTeam: [],
          // IncubatorDetails: [],
          FundDetails: [],
          // OtherDetails: [],
        })
        setTeamError([])

        // if (!localStorage.loadIncubator) {
        //   localStorage.setItem("loadIncubator", "true");
        //   window.location.reload();
        // }
      }
      else {
        ////console.log("ELSE");
        setApplicationId(props.location.state.application_id);
      }
      //console.log(teamError,"239")
    }
    else {
      history.push('/incubator_status');
      // if (!localStorage.setApplication) {

      //   post(CREATE_EMPTY_APPLICATION, null).then((response) => {
      //     if (!response.data) return;
      //     localStorage.setItem("setApplication", response.data.incubator_application_no);
      //     setApplicationId(response.data.incubator_application_no);
      //   });

      // }else if(localStorage.setApplication){
      //   setApplicationId(localStorage.setApplication);
      // }
    }

    stepper = new Stepper(
      document.querySelector("#incubatorstepper") as Element,
      {
        linear: false,
        animation: true,
      }
    );
    // fetch application records for each tabs and convert it into respective models
    // getActiveApplication();
    setStepperRef(stepper);
    window.scrollTo(0, 0);
  }, []);

  // Set disabled flag when we can view application when it's submitted
  const setDisabledFlag = (flag: boolean) => {
    setDisabled(true);
  };

  const handleSubmittedApplication = () => {
    window.location.reload();
  }

  //view active application
  const viewActiveApplication = (incubator_application_no: any) => {
    post(GET_RE_APPLICATION_VIEW, { incubator_application_no: incubator_application_no }).then(
      async (response: any) => {
        if (!response || !response.data) return;

        if (response.data.data[0]) {
          // 1st Step
          bindGeneralDetail(response, incubator);

          // 2nd Step
          bindIncubatorTeam(response, incubator);

          // 3rd Step
          bindIncubatorDetail(response, incubator);

          // 4th Step
          bindFundDetail(response, incubator);

          // await bindFiles(response, incubator);

          // bindOtherDetail(response, incubator);

          setIncubator((prevState: IIncubatorModel2) => {
            const updatedState = { ...prevState, incubator };
            return updatedState;
          });
        }
      }

    );
  };

  // bind files for all tabs
  const bindFiles = async (response: any, incubator: IIncubatorModel2) => {
    const { file_data } = response.data.data?.applicationData;
    // incubator = JSON.parse(JSON.stringify(incubator));
    if (file_data) {
      Object.keys(file_data).length &&
        Object.keys(file_data).map((key: string) => {
          switch (key) {
            case UploadTypeEnum.AnnualReport:
              // if(file_data[key]?.length){
              //   tempIncubator.GeneralDetail.annual_report = file_data[key]
              // }
              file_data[key].map((data: any) => {
                createFile(data.file).then((blob: any) => {
                  blob.lastModifiedDate = new Date();
                  const src = data.file as string;
                  blob.name = src.substr(src.lastIndexOf("/") + 1, src.length);
                  const file: FileUploadModel = new FileUploadModel(
                    data.file_id,
                    data.file_type_id,
                    blob as File
                  );
                  // incubator.GeneralDetail.annual_report = [
                  //   ...incubator.GeneralDetail.annual_report,
                  //   file,
                  // ];
                  setIncubator((prevState: IIncubatorModel2) => {
                    const updatedState = { ...prevState, incubator };
                    return updatedState;
                  });
                });
              });

              break;

            case UploadTypeEnum.ProofAssistance:
              file_data[key].map((data: any) => {
                createFile(data.file).then((blob: any) => {
                  blob.lastModifiedDate = new Date();
                  const src = data.file as string;
                  blob.name = src.substr(src.lastIndexOf("/") + 1, src.length);
                  const file: FileUploadModel = new FileUploadModel(
                    data.file_id,
                    data.file_type_id,
                    blob as File
                  );

                  // incubator.GeneralDetail.proof_assistance = [
                  //   ...incubator.GeneralDetail.proof_assistance,
                  //   file,
                  // ];
                  //setIncubator(tempIncubator);
                  setIncubator((prevState: IIncubatorModel2) => {
                    const updatedState = { ...prevState, incubator };
                    return updatedState;
                  });
                });
              });
              // setIncubator(tempIncubator);
              break;

            case UploadTypeEnum.RelaventDocumentExcel:
              file_data[key].map((data: any) => {
                createFile(data.file).then((blob: any) => {
                  blob.lastModifiedDate = new Date();
                  const src = data.file as string;
                  blob.name = src.substr(src.lastIndexOf("/") + 1, src.length);
                  const file: FileUploadModel = new FileUploadModel(
                    data.file_id,
                    data.file_type_id,
                    blob as File
                  );

                  // incubator.OtherDetails.relavent_document_excel = [
                  //   ...incubator.OtherDetails.relavent_document_excel,
                  //   file,
                  // ];
                  setIncubator((prevState: IIncubatorModel2) => {
                    const updatedState = { ...prevState, incubator };
                    return updatedState;
                  });
                  //setIncubator(tempIncubator);
                });
              });
              // setIncubator(tempIncubator);
              break;

            case UploadTypeEnum.ReleventDocumentPitchDeck:
              file_data[key].map((data: any) => {
                createFile(data.file).then((blob: any) => {
                  blob.lastModifiedDate = new Date();
                  const src = data.file as string;
                  blob.name = src.substr(src.lastIndexOf("/") + 1, src.length);
                  const file: FileUploadModel = new FileUploadModel(
                    data.file_id,
                    data.file_type_id,
                    blob as File
                  );

                  // incubator.OtherDetails.relavent_document_pitchdeck = [
                  //   ...incubator.OtherDetails.relavent_document_pitchdeck,
                  //   file,
                  // ];
                  setIncubator((prevState: IIncubatorModel2) => {
                    const updatedState = { ...prevState, incubator };
                    return updatedState;
                  });
                  //setIncubator(tempIncubator);
                });
              });
              // setIncubator(tempIncubator);
              break;

            case UploadTypeEnum.RelaventDocumentOther:
              file_data[key].map((data: any) => {
                createFile(data.file).then((blob: any) => {
                  blob.lastModifiedDate = new Date();
                  const src = data.file as string;
                  blob.name = src.substr(src.lastIndexOf("/") + 1, src.length);
                  const file: FileUploadModel = new FileUploadModel(
                    data.file_id,
                    data.file_type_id,
                    blob as File
                  );

                  // incubator.OtherDetails.relavent_document_other = [
                  //   ...incubator.OtherDetails.relavent_document_other,
                  //   file,
                  // ];
                  setIncubator((prevState: IIncubatorModel2) => {
                    const updatedState = { ...prevState, incubator };
                    return updatedState;
                  });
                  //setIncubator(tempIncubator);
                });
              });
              // setIncubator(tempIncubator);
              break;

            case UploadTypeEnum.IncorporationCertificate:
              file_data[key].map((data: any) => {
                createFile(data.file).then((blob: any) => {
                  blob.lastModifiedDate = new Date();
                  const src = data.file as string;
                  blob.name = src.substr(src.lastIndexOf("/") + 1, src.length);
                  const file: FileUploadModel = new FileUploadModel(
                    data.file_id,
                    data.file_type_id,
                    blob as File
                  );

                  // incubator.GeneralDetail.incorporation_certificate = [
                  //   ...incubator.GeneralDetail.incorporation_certificate,
                  //   file,
                  // ];
                  setIncubator((prevState: IIncubatorModel2) => {
                    const updatedState = { ...prevState, incubator };
                    return updatedState;
                  });
                  //setIncubator(tempIncubator);
                });
              });
              // setIncubator(tempIncubator);
              break;

            case UploadTypeEnum.TeamMemberCV:
              file_data[key].map((data: any) => {
                createFile(data.file).then((blob: any) => {
                  blob.lastModifiedDate = new Date();
                  const src = data.file as string;
                  blob.name = src.substr(src.lastIndexOf("/") + 1, src.length);
                  const file: FileUploadModel = new FileUploadModel(
                    data.file_id,
                    data.file_type_id,
                    blob as File
                  );

                  // incubator.OtherDetails.team_members_cv = [
                  //   ...incubator.OtherDetails.team_members_cv,
                  //   file,
                  // ];
                  setIncubator((prevState: IIncubatorModel2) => {
                    const updatedState = { ...prevState, incubator };
                    return updatedState;
                  });
                  //setIncubator(tempIncubator);
                });
              });
              // setIncubator(tempIncubator);
              break;

            case UploadTypeEnum.FacilitiesPictures:
              file_data[key].map((data: any) => {
                createFile(data.file).then((blob: any) => {
                  blob.lastModifiedDate = new Date();
                  const src = data.file as string;
                  blob.name = src.substr(src.lastIndexOf("/") + 1, src.length);
                  const file: FileUploadModel = new FileUploadModel(
                    data.file_id,
                    data.file_type_id,
                    blob as File
                  );

                  // incubator.IncubatorDetails.facilities_pictures = [
                  //   ...incubator.IncubatorDetails.facilities_pictures,
                  //   file,
                  // ];
                  setIncubator((prevState: IIncubatorModel2) => {
                    const updatedState = { ...prevState, incubator };
                    return updatedState;
                  });
                  // setIncubator(tempIncubator);
                });
              });
              // setIncubator(tempIncubator);
              break;

            case UploadTypeEnum.PanCardUpload:
              file_data[key].map((data: any) => {
                createFile(data.file).then((blob: any) => {
                  blob.lastModifiedDate = new Date();
                  const src = data.file as string;
                  blob.name = src.substr(src.lastIndexOf("/") + 1, src.length);
                  const file: FileUploadModel = new FileUploadModel(
                    data.file_id,
                    data.file_type_id,
                    blob as File
                  );

                  // incubator.GeneralDetail.pan_card_upload = [
                  //   ...incubator.GeneralDetail.pan_card_upload,
                  //   file,
                  // ];
                  setIncubator((prevState: IIncubatorModel2) => {
                    const updatedState = { ...prevState, incubator };
                    return updatedState;
                  });

                });
              });
              break;

            case UploadTypeEnum.AuthorisationLetterUpload:
              file_data[key].map((data: any) => {
                createFile(data.file).then((blob: any) => {
                  blob.lastModifiedDate = new Date();
                  const src = data.file as string;
                  blob.name = src.substr(src.lastIndexOf("/") + 1, src.length);
                  const file: FileUploadModel = new FileUploadModel(
                    data.file_id,
                    data.file_type_id,
                    blob as File
                  );

                  // incubator.GeneralDetail.authorisation_letter_upload = [
                  //   ...incubator.GeneralDetail.authorisation_letter_upload,
                  //   file,
                  // ];
                  setIncubator((prevState: IIncubatorModel2) => {
                    const updatedState = { ...prevState, incubator };
                    return updatedState;
                  });

                });
              });
              break;



            case UploadTypeEnum.AdhaarCardUpload:
              file_data[key].map((data: any) => {
                createFile(data.file).then((blob: any) => {
                  blob.lastModifiedDate = new Date();
                  const src = data.file as string;
                  blob.name = src.substr(src.lastIndexOf("/") + 1, src.length);
                  const file: FileUploadModel = new FileUploadModel(
                    data.file_id,
                    data.file_type_id,
                    blob as File
                  );

                  // incubator.GeneralDetail.adhaar_card_upload = [
                  //   ...incubator.GeneralDetail.adhaar_card_upload,
                  //   file,
                  // ];
                  setIncubator((prevState: IIncubatorModel2) => {
                    const updatedState = { ...prevState, incubator };
                    return updatedState;
                  });

                });
              });
              break;

            case UploadTypeEnum.StartupIncubationUpload:
              file_data[key].map((data: any) => {
                createFile(data.file).then((blob: any) => {
                  blob.lastModifiedDate = new Date();
                  const src = data.file as string;
                  blob.name = src.substr(src.lastIndexOf("/") + 1, src.length);
                  const file: FileUploadModel = new FileUploadModel(
                    data.file_id,
                    data.file_type_id,
                    blob as File
                  );

                  // incubator.GeneralDetail.startup_incubation_upload = [
                  //   ...incubator.GeneralDetail.startup_incubation_upload,
                  //   file,
                  // ];
                  setIncubator((prevState: IIncubatorModel2) => {
                    const updatedState = { ...prevState, incubator };
                    return updatedState;
                  });

                });
              });
              break;

            case UploadTypeEnum.SelfDeclarationUpload:
              file_data[key].map((data: any) => {
                createFile(data.file).then((blob: any) => {
                  blob.lastModifiedDate = new Date();
                  const src = data.file as string;
                  blob.name = src.substr(src.lastIndexOf("/") + 1, src.length);
                  const file: FileUploadModel = new FileUploadModel(
                    data.file_id,
                    data.file_type_id,
                    blob as File
                  );

                  // incubator.OtherDetails.self_declaration_upload = [
                  //   ...incubator.OtherDetails.self_declaration_upload,
                  //   file,
                  // ];
                  setIncubator((prevState: IIncubatorModel2) => {
                    const updatedState = { ...prevState, incubator };
                    return updatedState;
                  });

                });
              });
              break;

          }
        });
    }
  };

  const onSave = (stepperIndex: number, object: any, request: any) => {
    ////console.log('OBJ', object);
    switch (stepperIndex) {
      case StepperEnum.GeneralDetail:
        incubator.GeneralDetail = object;
        setIncubator(incubator)
        break;
      // case StepperEnum.IncubatorTeam:
      //   incubator.IncubatorTeam = object;
      //   break;
      // case StepperEnum.IncubatorDetail:
      //   incubator.IncubatorDetails = object;
      //   break;
        case StepperEnum.FundUtilization:
        incubator.FundDetails = object;
        break;
    }
    const user: any = getSessionStorageValue("user");
    const userInfo = JSON.parse(user)
    const userId = userInfo.id
    const formData = new FormData();
    // ////console.log(applicationId,"new")
    //  ////console.log(incubator.GeneralDetail.No_full_time_employees_upload)
    formData.append("logged_user_id", userId);
    formData.append("incubator_application_no", applicationId == '0' ? '0' : applicationId);


    // formData.append("No_individuals", (incubator.GeneralDetail.No_individuals == "" ? null : incubator.GeneralDetail.No_individuals));

    // formData.append("No_startups_undergoing", (incubator.GeneralDetail.No_startups_undergoing == "" ? null : incubator.GeneralDetail.No_startups_undergoing));

    // formData.append("List_significant_facilities", (incubator.GeneralDetail.List_significant_facilities == "" ? "0" : incubator.GeneralDetail.List_significant_facilities.toString()));

    //**************************************************************************************************/
    //Signinificant File Uplaod Code Starts
    ////console.log(significantfileuploadArray);
    // const List_significant_facilities_upload_Filetype = typeof (incubator.GeneralDetail.List_significant_facilities_upload);
    ////console.log("================FILETYPE========================", List_significant_facilities_upload_Filetype)
    // const significantfilessplice = incubator.GeneralDetail.List_significant_facilities_upload_get
    // if (incubator.GeneralDetail.List_significant_facilities_upload.length > 0 && List_significant_facilities_upload_Filetype != "string") {
      ////console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$ New Files Uploading $$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$")
      // for (var k = 0; k < incubator.GeneralDetail.List_significant_facilities_upload.length; k++) {
      //   formData.append("List_significant_facilities_upload", incubator.GeneralDetail.List_significant_facilities_upload[k]);
      // }
      // if (significantfileuploadArray.length > 0) {
        ////console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! ASSIGNING DATA FOR GET !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!")
      //   formData.append("List_significant_facilities_upload_get", significantfileuploadArray);
      //   formData.append("List_significant_facilities_upload_slice", significantfilessplice);
      // }
      // else {
        ////console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@ ASSIGNING DATA FOR GET IN ELSE @@@@@@@@@@@@@@@@@@@@@@@@@@@@ ")
    //     formData.append("List_significant_facilities_upload_get", significantfileuploadArray);
    //     formData.append("List_significant_facilities_upload_slice", significantfilessplice);
    //   }
    // }
    // else {
      ////console.log(" %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% MAIN ELSE %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%");
    //   formData.append("List_significant_facilities_upload", "0");
    //   formData.append("List_significant_facilities_upload_get", significantfileuploadArray);
    //   formData.append("List_significant_facilities_upload_slice", significantfilessplice);
    // }
    //Signinificant File Uplaod Code Ends
    //**************************************************************************************************
    //No of Full time employees File Uplaod Code Starts
    ////console.log(fulltimeEmployeesArray);
    // const No_full_time_employees_upload_Filetype = typeof (incubator.GeneralDetail.No_full_time_employees_upload);
    // const fulltimeempfilessplice = incubator.GeneralDetail.No_full_time_employees_upload_get;
    // if (incubator.GeneralDetail.No_full_time_employees_upload.length > 0 && No_full_time_employees_upload_Filetype != "string") {
    //   for (var j = 0; j < incubator.GeneralDetail.No_full_time_employees_upload.length; j++) {
    //     formData.append("No_full_time_employees_upload", incubator.GeneralDetail.No_full_time_employees_upload[j]);
    //   }
    //   if (fulltimeEmployeesArray.length > 0) {
        ////console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! ASSIGNING DATA FOR GET !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!")
      //   formData.append("No_full_time_employees_upload_get", fulltimeEmployeesArray);
      //   formData.append("No_full_time_employees_upload_slice", fulltimeempfilessplice);
      // }
      // else {
        ////console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@ ASSIGNING DATA FOR GET IN ELSE @@@@@@@@@@@@@@@@@@@@@@@@@@@@ ")
        // formData.append("No_full_time_employees_upload_get", fulltimeEmployeesArray);
        // formData.append("No_full_time_employees_upload_slice", fulltimeempfilessplice);
      // }
    // }
    // else {
    //   formData.append("No_full_time_employees_upload", "0");
    //   formData.append("No_full_time_employees_upload_get", fulltimeEmployeesArray);
    //   formData.append("No_full_time_employees_upload_slice", fulltimeempfilessplice);
    // }
    //No of Full time employees File Uplaod Code Ends
    //**************************************************************************************************

    //pitch deck code start
    const Re_apply_pitchdeck_upload_Filetype = typeof (incubator.GeneralDetail.Re_apply_pitchdeck_upload);
    const pitchdecksplice = incubator.GeneralDetail.Re_apply_pitchdeck_upload_get;
    if (incubator.GeneralDetail.Re_apply_pitchdeck_upload.length > 0 && Re_apply_pitchdeck_upload_Filetype != "string") {
      for (var j = 0; j < incubator.GeneralDetail.Re_apply_pitchdeck_upload.length; j++) {
        formData.append("Re_apply_pitchdeck_upload", incubator.GeneralDetail.Re_apply_pitchdeck_upload[j]);
      }
      if (pitchdeckArray.length > 0) {
        ////console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! ASSIGNING DATA FOR GET !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!")
        formData.append("Re_apply_pitchdeck_upload_get", pitchdeckArray);
        formData.append("Re_apply_pitchdeck_upload_slice", pitchdecksplice);
      }
      else {
        ////console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@ ASSIGNING DATA FOR GET IN ELSE @@@@@@@@@@@@@@@@@@@@@@@@@@@@ ")
        formData.append("Re_apply_pitchdeck_upload_get", pitchdeckArray);
        formData.append("Re_apply_pitchdeck_upload_slice", pitchdecksplice);
      }
    }
    else {
      formData.append("Re_apply_pitchdeck_upload", "0");
      formData.append("Re_apply_pitchdeck_upload_get", pitchdeckArray);
      formData.append("Re_apply_pitchdeck_upload_slice", pitchdecksplice);
    }
    //ptch deck code end

    //performance upload code starts
    const Performance_Upload_Filetype = typeof (incubator.GeneralDetail.Performance_Upload);
    const performancesplice = incubator.GeneralDetail.Performance_Upload_get;
    if (incubator.GeneralDetail.Performance_Upload.length > 0 && Performance_Upload_Filetype != "string") {
      for (var j = 0; j < incubator.GeneralDetail.Performance_Upload.length; j++) {
        formData.append("Performance_Upload", incubator.GeneralDetail.Performance_Upload[j]);
      }
      if (performanceArray.length > 0) {
        ////console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! ASSIGNING DATA FOR GET !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!")
        formData.append("Performance_Upload_get", performanceArray);
        formData.append("Performance_Upload_slice", performancesplice);
      }
      else {
        ////console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@ ASSIGNING DATA FOR GET IN ELSE @@@@@@@@@@@@@@@@@@@@@@@@@@@@ ")
        formData.append("Performance_Upload_get", performanceArray);
        formData.append("Performance_Upload_slice", performancesplice);
      }
    }
    else {
      formData.append("Performance_Upload", "0");
      formData.append("Performance_Upload_get", performanceArray);
      formData.append("Performance_Upload_slice", performancesplice);
    }
    //performance upload end


    //other document upload code starts
    const Other_document_upload_Filetype = typeof (incubator.GeneralDetail.Other_document_upload);
    const otherdocsplice = incubator.GeneralDetail.Other_document_upload_get;
    if (incubator.GeneralDetail.Other_document_upload.length > 0 && Other_document_upload_Filetype != "string") {
      for (var j = 0; j < incubator.GeneralDetail.Other_document_upload.length; j++) {
        formData.append("Other_document_upload", incubator.GeneralDetail.Other_document_upload[j]);
      }
      if (otherdocArray.length > 0) {
        ////console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! ASSIGNING DATA FOR GET !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!")
        formData.append("Other_document_upload_get", otherdocArray);
        formData.append("Other_document_upload_slice", otherdocsplice);
      }
      else {
        ////console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@ ASSIGNING DATA FOR GET IN ELSE @@@@@@@@@@@@@@@@@@@@@@@@@@@@ ")
        formData.append("Other_document_upload_get", otherdocArray);
        formData.append("Other_document_upload_slice", otherdocsplice);
      }
    }
    else {
      formData.append("Other_document_upload", "0");
      formData.append("Other_document_upload_get", otherdocArray);
      formData.append("Other_document_upload_slice", otherdocsplice);
    }
    //other document upload code ends

    //console.log(incubator.GeneralDetail.team_data)

    formData.append("No_startups_incubated", (incubator.GeneralDetail.No_startups_incubated == "" ? null : incubator.GeneralDetail.No_startups_incubated));

    formData.append("No_startups_graduated", (incubator.GeneralDetail.No_startups_graduated == "" ? null : incubator.GeneralDetail.No_startups_graduated));

    formData.append("No_startups_raised", (incubator.GeneralDetail.No_startups_raised == "" ? null : incubator.GeneralDetail.No_startups_raised));

    formData.append("No_startups_crossed", (incubator.GeneralDetail.No_startups_crossed == "" ? null : incubator.GeneralDetail.No_startups_crossed));

    formData.append("survival_rate_startups", (incubator.GeneralDetail.survival_rate_startups == "" ? null : incubator.GeneralDetail.survival_rate_startups));

    formData.append("Investment_agreements_signed", (incubator.GeneralDetail.Investment_agreements_signed == "" ? null : incubator.GeneralDetail.Investment_agreements_signed));

    formData.append("No_startups_invested", (incubator.GeneralDetail.No_startups_invested == "" ? null : incubator.GeneralDetail.No_startups_invested));

    formData.append("allocated_incubatees", (incubator.GeneralDetail.allocated_incubatees == "" ? null : incubator.GeneralDetail.allocated_incubatees));

    formData.append("external_sources", (incubator.GeneralDetail.external_sources == "" ? null : incubator.GeneralDetail.external_sources));

    formData.append("No_mentors_actively", (incubator.GeneralDetail.No_mentors_actively == "" ? null : incubator.GeneralDetail.No_mentors_actively));

    formData.append("allocated_startup_month", (incubator.GeneralDetail.allocated_startup_month == "" ? null : incubator.GeneralDetail.allocated_startup_month));

    formData.append("No_patents_registered", (incubator.GeneralDetail.No_patents_registered == "" ? null : incubator.GeneralDetail.No_patents_registered));

    formData.append("No_patents_copyrights", (incubator.GeneralDetail.No_patents_copyrights == "" ? null : incubator.GeneralDetail.No_patents_copyrights));

    formData.append("No_trademarks_registered", (incubator.GeneralDetail.No_trademarks_registered == "" ? null : incubator.GeneralDetail.No_trademarks_registered));

    formData.append("Corporate_connects_facilitated", (incubator.GeneralDetail.Corporate_connects_facilitated == "" ? null : incubator.GeneralDetail.Corporate_connects_facilitated));

    formData.append("Events_stakeholder_engagements", (incubator.GeneralDetail.Events_stakeholder_engagements == "" ? null : incubator.GeneralDetail.Events_stakeholder_engagements));

    formData.append("Participation_Event", (incubator.GeneralDetail.Participation_Event == "" ? null : incubator.GeneralDetail.Participation_Event));

    formData.append("Name_Background_current", (incubator.GeneralDetail.Name_Background_current == "" ? "0" : incubator.GeneralDetail.Name_Background_current));

    // formData.append("No_full_time_employees", (incubator.GeneralDetail.No_full_time_employees == "" ? null : incubator.GeneralDetail.No_full_time_employees));

    // formData.append("No_full_time_employees_upload",(incubator.GeneralDetail.No_full_time_employees_upload==""?null:incubator.GeneralDetail.No_full_time_employees_upload));
    // if(incubator.GeneralDetail.No_full_time_employees_upload > 0){

    //   for (var i = 0; i < incubator.GeneralDetail.No_full_time_employees_upload.length; i++) {
    //   formData.append("No_full_time_employees_upload",incubator.GeneralDetail.No_full_time_employees_upload[i]);
    //   }}else{
    //   formData.append("No_full_time_employees_upload","0");

    //   }

    // formData.append("team_data",(JSON.stringify(incubator.GeneralDetail.team_data)))
    // formData.append("team_data",(incubator.GeneralDetail.team_data.map((res:any)=>{
    //       return res.team_name
    // }) ==0? 0:incubator.GeneralDetail.team_data.map((res:any)=>{
    //       return res.team_name
    //       }))
    // formData.append("team_data",(JSON.stringify(incubator.GeneralDetail.team_data)))

    formData.append("team_data", (JSON.stringify(incubator.GeneralDetail.team_data)))
     formData.append("mteam_name", (incubator.GeneralDetail.mteam_name == 0 ? 0 : incubator.GeneralDetail.mteam_name));
     formData.append("New", (incubator.GeneralDetail.New == "" ? null : incubator.GeneralDetail.New));
    // formData.append("team_data",(JSON.stringify(incubator.GeneralDetail.team_data.map((res)=>{return res.team_name==""}) ?0:JSON.stringify(incubator.GeneralDetail.team_data ) )))
    
    // formData.append("sum_disbured", (incubator.GeneralDetail.sum_disbured));

    formData.append("Fund_Utilization_Details", (incubator.GeneralDetail.Fund_Utilization_Details == 0 ? 0 : incubator.GeneralDetail.Fund_Utilization_Details));
    formData.append("fulltime_employees_re_apply",(incubator.GeneralDetail.fulltime_employees_re_apply == "" ? null : incubator.GeneralDetail.fulltime_employees_re_apply));
    // //console.log(incubator.GeneralDetail.re_apply_upload_documents_composition_incubator,"834")
    

    // 0:(incubator.GeneralDetail.re_apply_upload_documents_composition_incubator == 'true'?'1':'0')))
    // formData.append("re_apply_upload_documents_incubation_support",(incubator.GeneralDetail.re_apply_upload_documents_incubation_support == ""? 0:incubator.GeneralDetail.re_apply_upload_documents_incubation_support))
    // formData.append("re_apply_upload_documents_mentorship_provided",(incubator.GeneralDetail.re_apply_upload_documents_mentorship_provided ==""?0:incubator.GeneralDetail.re_apply_upload_documents_mentorship_provided))
    // formData.append("re_apply_upload_documents_events_organized",(incubator.GeneralDetail.re_apply_upload_documents_events_organized ==""?0:incubator.GeneralDetail.re_apply_upload_documents_events_organized))
    formData.append("quantum_fund_required_re_apply",(incubator.FundDetails.quantum_fund_required_re_apply ==""?0:incubator.FundDetails.quantum_fund_required_re_apply));
    formData.append("no_fund_benifitiaries_1yr_re_apply",(incubator.FundDetails.no_fund_benifitiaries_1yr_re_apply == 0?0:incubator.FundDetails.no_fund_benifitiaries_1yr_re_apply));
    formData.append("no_fund_benifitiaries_2yr_re_apply",(incubator.FundDetails.no_fund_benifitiaries_2yr_re_apply == 0?0:incubator.FundDetails.no_fund_benifitiaries_2yr_re_apply));
    formData.append("no_fund_benifitiaries_3yr_re_apply",(incubator.FundDetails.no_fund_benifitiaries_3yr_re_apply == 0?0:incubator.FundDetails.no_fund_benifitiaries_3yr_re_apply));
    //**************************************************************************************************
    //Utilization Certificate  File Uplaod Code Starts
    ////console.log(ucfilesArray);
    // const Utilization_Certificate_Upload_Filetype = typeof (incubator.IncubatorTeam.Utilization_Certificate_Upload);
    // const ucfilessplice = incubator.IncubatorTeam.Utilization_Certificate_Upload_get;
    // if (incubator.IncubatorTeam.Utilization_Certificate_Upload.length > 0 && Utilization_Certificate_Upload_Filetype != "string") {
    //   for (var i = 0; i < incubator.IncubatorTeam.Utilization_Certificate_Upload.length; i++) {
    //     formData.append("Utilization_Certificate_Upload", incubator.IncubatorTeam.Utilization_Certificate_Upload[i]);
    //   }
    //   if (ucfilesArray.length > 0) {
    //     formData.append("Utilization_Certificate_Upload_get", ucfilesArray);
    //     formData.append("Utilization_Certificate_Upload_slice", ucfilessplice);
    //   }
    //   else {
    //     formData.append("Utilization_Certificate_Upload_get", ucfilesArray);
    //     formData.append("Utilization_Certificate_Upload_slice", ucfilessplice);
    //   }
    // } 
    // else {
    //   formData.append("Utilization_Certificate_Upload", "0");
    //   formData.append("Utilization_Certificate_Upload_get", ucfilesArray);
    //   formData.append("Utilization_Certificate_Upload_slice", ucfilessplice);
    // } 
    //Utilization Certificate  File Uplaod Code Ends
    //**************************************************************************************************
    // const Audited_statement_expenditure_Upload_Filetype = typeof (incubator.IncubatorTeam.Audited_statement_expenditure_Upload);
    // const auditfilessplice = incubator.IncubatorTeam.Audited_statement_expenditure_Upload_get;

    // if (incubator.IncubatorTeam.Audited_statement_expenditure_Upload.length > 0 && Audited_statement_expenditure_Upload_Filetype != "string") {

    //   for (var j = 0; j < incubator.IncubatorTeam.Audited_statement_expenditure_Upload.length; j++) {
    //     formData.append("Audited_statement_expenditure_Upload", incubator.IncubatorTeam.Audited_statement_expenditure_Upload[j]);
    //   }
    //   if (AuditedfilesArray.length > 0) {
    //     formData.append("Audited_statement_expenditure_Upload_get", AuditedfilesArray);
    //     formData.append("Audited_statement_expenditure_Upload_slice", auditfilessplice);
    //   }
    //   else {
    //     formData.append("Audited_statement_expenditure_Upload_get", AuditedfilesArray);
    //     formData.append("Audited_statement_expenditure_Upload_slice", auditfilessplice);
    //   }
    // } else {
    //   formData.append("Audited_statement_expenditure_Upload", "0");
    //   formData.append("Audited_statement_expenditure_Upload_get", AuditedfilesArray);
    //   formData.append("Audited_statement_expenditure_Upload_slice", auditfilessplice);
    // }
    //**************************************************************************************************

    // if(incubator.IncubatorTeam.Declaration_violation_SISFS_Upload.length > 0){

    // for (var j = 0; j < incubator.IncubatorTeam.Declaration_violation_SISFS_Upload.length; j++) {
    //   formData.append("Declaration_violation_SISFS_Upload",incubator.IncubatorTeam.Declaration_violation_SISFS_Upload[j]);
    // }}else{
    //   formData.append("Declaration_violation_SISFS_Upload","0");

    // }

  //**************************************************************************************************
  // const Current_Incubator_Team_Upload_Filetype = typeof (incubator.IncubatorDetails.Current_Incubator_Team_Upload);
  // const currentIncfilessplice = incubator.IncubatorDetails.Current_Incubator_Team_Upload_get;
  //   if (incubator.IncubatorDetails.Current_Incubator_Team_Upload.length > 0 && Current_Incubator_Team_Upload_Filetype != "string") {
  //     for (var j = 0; j < incubator.IncubatorDetails.Current_Incubator_Team_Upload.length; j++) {
  //       formData.append("Current_Incubator_Team_Upload", incubator.IncubatorDetails.Current_Incubator_Team_Upload[j]);
  //     }
  //     if (AuditedfilesArray.length > 0) {
        ////console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! ASSIGNING DATA FOR GET !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!")
      //   formData.append("Current_Incubator_Team_Upload_get", AuditedfilesArray);
      //   formData.append("Current_Incubator_Team_Upload_slice", currentIncfilessplice);
      // }
      // else {
        ////console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@ ASSIGNING DATA FOR GET IN ELSE @@@@@@@@@@@@@@@@@@@@@@@@@@@@ ")
    //     formData.append("Current_Incubator_Team_Upload_get", AuditedfilesArray);
    //     formData.append("Current_Incubator_Team_Upload_slice", currentIncfilessplice);
    //   }


    // } else {
    //   formData.append("Current_Incubator_Team_Upload", "0");
    //   formData.append("Current_Incubator_Team_Upload_get", AuditedfilesArray);
    //   formData.append("Current_Incubator_Team_Upload_slice", currentIncfilessplice);

    // }
    //**************************************************************************************************


    // formData.append("Details_Interest_earned", (incubator.IncubatorTeam.Details_Interest_earned == "" ? null : incubator.IncubatorTeam.Details_Interest_earned));

    // formData.append("Grant_Disbursed", (incubator.IncubatorTeam.Grant_Disbursed == "" ? null : incubator.IncubatorTeam.Grant_Disbursed));

    // formData.append("Debt_Disbursed_Interest_Earned",(incubator.IncubatorTeam.Debt_Disbursed_Interest_Earned==""?null:incubator.IncubatorTeam.Debt_Disbursed_Interest_Earned));

    // formData.append("Debentures_Disbursed_Interest_Earned",(incubator.IncubatorTeam.Debentures_Disbursed_Interest_Earned==""?null:incubator.IncubatorTeam.Debentures_Disbursed_Interest_Earned));

    // formData.append("Debt_Disbursed", (incubator.IncubatorTeam.Debt_Disbursed == "" ? null : incubator.IncubatorTeam.Debt_Disbursed));

    // formData.append("Debt_Interest", (incubator.IncubatorTeam.Debt_Interest == "" ? null : incubator.IncubatorTeam.Debt_Interest));

    // formData.append("Debt_Other_Earned", (incubator.IncubatorTeam.Debt_Other_Earned == "" ? null : incubator.IncubatorTeam.Debt_Other_Earned));

    // formData.append("Debentures_Disbursed", (incubator.IncubatorTeam.Debentures_Disbursed == "" ? null : incubator.IncubatorTeam.Debentures_Disbursed));

    // formData.append("Debentures_Interest_Earned", (incubator.IncubatorTeam.Debentures_Interest_Earned == "" ? null : incubator.IncubatorTeam.Debentures_Interest_Earned));

    // formData.append("Debentures_Other_Earned", (incubator.IncubatorTeam.Debentures_Other_Earned == "" ? null : incubator.IncubatorTeam.Debentures_Other_Earned));

    // formData.append("action",incubator.IncubatorDetails.action);

    // formData.append("No_Startup_Applications_Received", (incubator.IncubatorDetails.No_Startup_Applications_Received));

    // formData.append("open_applications", (incubator.IncubatorDetails.open_applications));

    // formData.append("No_Startup_Applications_Reviewed", (incubator.IncubatorDetails.No_Startup_Applications_Reviewed));

    // formData.append("No_Startup_Applications_Selected", (incubator.IncubatorDetails.No_Startup_Applications_Selected));

    // formData.append("No_Startup_Applications_Allotted", (incubator.IncubatorDetails.No_Startup_Applications_Allotted));

    // formData.append("No_Startup_whom_Agreements", (incubator.IncubatorDetails.No_Startup_whom_Agreements == "" ? null : incubator.IncubatorDetails.No_Startup_whom_Agreements));

    // formData.append("No_Startup_Applications_Cancelled", (incubator.IncubatorDetails.No_Startup_Applications_Cancelled));

    // formData.append("No_Startup_Applications_Closed", (incubator.IncubatorDetails.No_Startup_Applications_Closed));

    // formData.append("No_industries_represented", (incubator.IncubatorDetails.No_industries_represented));

    // formData.append("No_States_represented", (incubator.IncubatorDetails.No_States_represented));

    // formData.append("Number_startups_PoC_stage", (incubator.IncubatorDetails.Number_startups_PoC_stage == "" ? null : incubator.IncubatorDetails.Number_startups_PoC_stage));

    // formData.append("Number_startups_Prototype", (incubator.IncubatorDetails.Number_startups_Prototype == "" ? null : incubator.IncubatorDetails.Number_startups_Prototype));

    // formData.append("Number_startups_Product_Development", (incubator.IncubatorDetails.Number_startups_Product_Development == "" ? null : incubator.IncubatorDetails.Number_startups_Product_Development));

    // formData.append("Number_startups_Field_Trial", (incubator.IncubatorDetails.Number_startups_Field_Trial == "" ? null : incubator.IncubatorDetails.Number_startups_Field_Trial));

    // formData.append("Number_startups_Market", (incubator.IncubatorDetails.Number_startups_Market == "" ? null : incubator.IncubatorDetails.Number_startups_Market));

    // formData.append("Number_startups_Other_Stage", (incubator.IncubatorDetails.Number_startups_Other_Stage == "" ? null : incubator.IncubatorDetails.Number_startups_Other_Stage));

    // formData.append("Cumulative_External_Funding", (incubator.IncubatorDetails.Cumulative_External_Funding == "" ? null : incubator.IncubatorDetails.Cumulative_External_Funding));

    // formData.append("No_People_Employed_Startups", (incubator.IncubatorDetails.No_People_Employed_Startups == "" ? null : incubator.IncubatorDetails.No_People_Employed_Startups));

    // formData.append("Turnover_Startups_financial", (incubator.IncubatorDetails.Turnover_Startups_financial == "" ? null : incubator.IncubatorDetails.Turnover_Startups_financial));

    // formData.append("GST_Filed_Startups", (incubator.IncubatorDetails.GST_Filed_Startups == "" ? null : incubator.IncubatorDetails.GST_Filed_Startups));

    // formData.append("No_Products_Services_Startups", (incubator.IncubatorDetails.No_Products_Services_Startups == "" ? null : incubator.IncubatorDetails.No_Products_Services_Startups));

    // formData.append("No_Registration_Requests_Filed", (incubator.IncubatorDetails.No_Registration_Requests_Filed == "" ? null : incubator.IncubatorDetails.No_Registration_Requests_Filed));

    // formData.append("Grants", (incubator.IncubatorDetails.Grants == "" ? null : incubator.IncubatorDetails.Grants));

    // formData.append("Convertible_Debentures", (incubator.IncubatorDetails.Convertible_Debentures == "" ? null : incubator.IncubatorDetails.Convertible_Debentures));

    // formData.append("Debt", (incubator.IncubatorDetails.Debt == "" ? null : incubator.IncubatorDetails.Debt));

    // formData.append("disbursed_Debt", (incubator.IncubatorDetails.disbursed_Debt == "" ? null : incubator.IncubatorDetails.disbursed_Debt));

    // formData.append("Funds_disbursed_Grants", (incubator.IncubatorDetails.Funds_disbursed_Grants == "" ? null : incubator.IncubatorDetails.Funds_disbursed_Grants));

    // formData.append("disbursed_Convertible_Debentures", (incubator.IncubatorDetails.disbursed_Convertible_Debentures == "" ? null : incubator.IncubatorDetails.disbursed_Convertible_Debentures));

    // formData.append("disbursed_Debt_Linked_Instruments", (incubator.IncubatorDetails.disbursed_Debt_Linked_Instruments == "" ? null : incubator.IncubatorDetails.disbursed_Debt_Linked_Instruments));

    // formData.append("Debt_Linked_Instruments", (incubator.IncubatorDetails.Debt_Linked_Instruments == "" ? null : incubator.IncubatorDetails.Debt_Linked_Instruments));

    // formData.append("Total_Interest_Debt_Due", (incubator.IncubatorDetails.Total_Interest_Debt_Due == "" ? null : incubator.IncubatorDetails.Total_Interest_Debt_Due));

    // formData.append("Total_Interest_Debt_Bank", (incubator.IncubatorDetails.Total_Interest_Debt_Bank == "" ? null : incubator.IncubatorDetails.Total_Interest_Debt_Bank));

    // formData.append("Principal_Amount_Returned", (incubator.IncubatorDetails.Principal_Amount_Returned == "" ? null : incubator.IncubatorDetails.Principal_Amount_Returned));

    // formData.append("Cumulative_Monetary_Return", (incubator.IncubatorDetails.Cumulative_Monetary_Return == "" ? null : incubator.IncubatorDetails.Cumulative_Monetary_Return));


    // formData.append("No_Testimonials_Success", (incubator.IncubatorDetails.No_Testimonials_Success == "" ? null : incubator.IncubatorDetails.No_Testimonials_Success));
    formData.append("status_id", request);

    let check: boolean = false;

    if (
      request === requestType.submit ||
      (request === requestType.propertyChange && isSubmitted)
    ) {

      isSubmitted = true;
      formError = validateIncubator(incubator);      
      check = request === requestType.submit && formError.error;

    }

    if (request !== requestType.submit) {
      incubator.FundDetails.action = "";
    }
    

    const hasFormError =
      formError &&
      (
        // formError.errors?.FundDetails.length ||
        formError.errors?.GeneralDetail.length ||
        // formError.errors?.IncubatorDetails.length
        // ||
        // formError.errors?.IncubatorTeam.length
        // ||
        formError.errors?.FundDetails.length
      );

      //console.log(incubator.GeneralDetail,"1099")
      // && check
    if (formError  && hasFormError > 0) {
      setValidator(formError.errors);

      return;
    } else if (
      isSubmitted &&
      request === requestType.propertyChange &&
      hasFormError > 0
    ) {
      
      setValidator(formError.errors);
      
    } else {
      check = false;
    }
    // let teamVal = incubator.GeneralDetail.team_data.map((data:any) =>{
    //   if(!data.team_name.length){
    //     return
    //   }else{

    //   }
    // })

    

    // incubator.GeneralDetail.team_data.map((res:any)=>{
    //    //console.log(res)
    //    if((res.team_name=="")||(res.no_employee=="")){
      
      
    //   }else{
     
    
    //  }
    // })


    
    if ((request == requestType.submit && !check )
      //   && !check) 
      ||
      (request == requestType.save )
    ) {
      

      // if (
      //   request === requestType.submit &&
      //   saveRequestModel.fund_disburse_using_3rd_party === "1"
      // ) {
      //   setStopSubmit(true);
      //   return;
      // }
      setStopSubmit(false);
      // setLoader(true);
      setDisabled(true);
      // ////console.log(formData,"save")
  // return
      post(GET_STORE_INCUBATOR_DATA, formData).then(
        (response: any) => {
          // ////console.log(response);
          // setApplication_number(response.data.data)
          if (!response || !response.data) {
            return;
          }
          // setDisabled(true)
          // setLoader(false);
          setDisabled(false);

          formError = null;
          isSubmitted = false;

          if (response.data.data != 0) {
            setApplicationId(response.data.data);
          }

          if (response.status === 200) {
            // show success message
            if (
              incubator.FundDetails.action &&
              incubator.FundDetails.action == "submit"
            ) {
              ////console.log("ADHi");
              setShowIncubatorSuccessModal(true);
            }
          } else {
            // show error message
            if (incubator.FundDetails.action && incubator.FundDetails.action == "") {
              setShowIncubatorErrorModal(true);
            }
          }
        }
      );
    }
    
  };

  // validate Incubator
  const validateIncubator = (data: any) => {
    //console.log(data,"dataa")
    setValidator({
      GeneralDetail: [],
      // IncubatorTeam: [],
      // IncubatorDetails: [],
      FundDetails: [],
      // OtherDetails: [],
    });
    //console.log(validator,"validatot")
    let errors: any = {
      GeneralDetail: [],
      IncubatorTeam: [],
      IncubatorDetails: [],
      FundDetails: [],
      // OtherDetails: [],
    };
    // //console.log(errors,"validatot")
    const parentKeys = Object.keys(data);
    let nonMandatoryFields = [
      "website_url",
      "facebook_enable",
      "linkedin_enable",
      "twitter_enable",
      "youtube_enable",
      "facebook_link",
      "twitter_link",
      "linkedin_link",
      "youtube_link",
      "no_of_patents",
      "no_of_patents_applicable",
      "no_of_copyrights",
      "no_of_copyrights_applicable",
      "no_of_trademarks",
      "no_of_trademarks_applicable",
      "relavent_document_other",
      "fund_disburse_using_3rd_party",
      "action",
      "mentors_average_hours",
      "incubator_name",
      "startups_invested_total_corpus_applicable",
      "total_investments_raised_incubatees_applicable",
      "mentors_average_hours_applicable",
      "startups_invested_applicable",
      "mentors_no_engaged_applicable",
      "corporate_facilitated_applicable",
      "event_engagements_applicable",
      "participation_other_events_applicable",
      "fulltime_employees_no",
      "upload_documents_incubation_support",
      "upload_documents_mentorship_provided",
      "upload_documents_composition_incubator",
      "upload_documents_events_organized",
      "relavent_document_pitchdeck",
      "startups_invested",
      "mentors_no_engaged",
      "mentors_no_of_ip",
      "no_fund_benifitiaries_1yr",
      "no_fund_benifitiaries_2yr",
      "no_fund_benifitiaries_3yr",
      "startups_no_incubated",
      "startups_no_graduated",
      "startups_no_investments",
      "startups_no_revenue_year",
      "startups_survival_rate",
      "investments_between_incubator_startups",
      "corporate_facilitated",
      "event_engagements",
      "participation_other_events",
      "startups_invested_total_corpus",
      "total_investments_raised_incubatees",
      "No_Startup_Applications_Received",
      "open_applications",
      "No_Startup_Applications_Reviewed",
      "No_Startup_Applications_Selected",
      "No_Startup_Applications_Allotted",
      "No_Startup_Applications_Cancelled",
      "No_Startup_Applications_Closed",
      "No_industries_represented",
      "No_States_represented",
      "Cumulative_Monetary_Return",
      "List_significant_facilities_upload_get",
      "List_significant_facilities_upload_slice",
      "Utilization_Certificate_Upload_get",
      "Utilization_Certificate_Upload_slice",
      "Audited_statement_expenditure_Upload_get",
      "Audited_statement_expenditure_Upload_slice",
      "Current_Incubator_Team_Upload_get",
      "Current_Incubator_Team_Upload_slice",
      "No_full_time_employees_upload_get",
      "No_full_time_employees_upload_slice",
      "re_apply_upload_documents_composition_incubator",
      "re_apply_upload_documents_incubation_support",
      "re_apply_upload_documents_mentorship_provided",
      "re_apply_upload_documents_events_organized",

      "checkbox_events_organized",
      "checkbox_composition_incubator",
      "checkbox_incubation_support",
      "checkbox_mentorship_provided",

      "no_fund_benifitiaries_1yr_re_apply",
      "no_fund_benifitiaries_2yr_re_apply",
      "no_fund_benifitiaries_3yr_re_apply",
      "List_significant_facilities_upload_slice",
      "List_significant_facilities_upload_get",
      "Re_Apply_relavant_excel",
      "Re_apply_relavent_document_pitchdeck",

      "Re_apply_pitchdeck_upload_get",
      "Re_apply_pitchdeck_upload_slice",
      "Other_document_upload_get",
      "Other_document_upload_slice",
      "Performance_Upload_get",
      "Performance_Upload_slice",
      "fulltime_employees_re_apply",

      "Fund_Utilization_Details",
      "team_data",
      "mteam_name",


      // 2nd form keys
      // "Utilization_Certificate_Upload",
      // "Utilization_Certificate_Upload_get",
      // "Utilization_Certificate_Upload_slice",  
      // "Details_Interest_earned",
      // "Grant_Disbursed",
      // "Debt_Disbursed",
      // "Debt_Interest",
      // "Debt_Other_Earned",
      // "Debentures_Disbursed",
      // "Debentures_Interest_Earned",
      // "Debentures_Other_Earned",
      // "Audited_statement_expenditure_Upload",
      // "Audited_statement_expenditure_Upload_get",
      // "Audited_statement_expenditure_Upload_slice",

      // 3rd form keys

      // "No_Startup_Applications_Received",
      // "open_applications",
      // "No_Startup_Applications_Reviewed",
      // "No_Startup_Applications_Selected",
      // "No_Startup_Applications_Allotted",
      // "No_Startup_whom_Agreements",
      // "No_Startup_Applications_Cancelled",
      // "No_Startup_Applications_Closed",
      // "No_industries_represented",
      // "No_States_represented",
      // "Number_startups_PoC_stage",
      // "Number_startups_Prototype",
      // "Number_startups_Product_Development",
      // "Number_startups_Field_Trial",
      // "Number_startups_Market",
      // "Number_startups_Other_Stage",
      // "Cumulative_External_Funding",
      // "No_People_Employed_Startups",
      // "Turnover_Startups_financial",
      // "GST_Filed_Startups",
      // "No_Products_Services_Startups",
      // "No_Registration_Requests_Filed",
      // "Grants",
      // "Convertible_Debentures",
      // "Debt",
      // "disbursed_Debt",
      // "Debt_Linked_Instruments",
      // "disbursed_Debt_Linked_Instruments",
      // "Funds_disbursed_Grants",
      // "disbursed_Convertible_Debentures",
      // "Total_Interest_Debt_Due",
      // "Total_Interest_Debt_Bank",
      // "Principal_Amount_Returned",
      // "Cumulative_Monetary_Return",
      
    ];
    let error = false;
    // let uniqueArray: any = [];
    // incubator.GeneralDetail.team_data.map((team: TeamDetails) =>{
    //   if(!team.team_name.length){
    //     uniqueArray.push(team)
    //     //console.log(uniqueArray,"teamError")
    //     error = false
    //   }
    //   else{
    //     error = true;
    //     setTeamError(uniqueArray)
    //     //console.log(uniqueArray,"teamError")
    //   }
    
    // })
    parentKeys.map((key, ind) => {
      Object.keys(data[key]).map((item) => {
        

        if (nonMandatoryFields.indexOf(item) < 0) {
          //console.log(item,"1392")

          //console.log()
          // //console.log()
          // if (item === "team_data") {
          //   let uniqueArray: any = [];
          //   data[key][item].length &&
          //     data[key][item].map((team: TeamDetails, ind: number) => {
          //       if (!team.team_name.length || team.no_employee < 0) {
          //         uniqueArray.push(ind);
          //         error = false;
          //       } else {
          //         uniqueArray.splice(uniqueArray.indexOf(ind), 1);
          //         error = true;
          //       }
          //     });
          //   let tempArray: any = [];
          //   uniqueArray.length &&
          //     uniqueArray.map(function (item: number, pos: number) {
          //       if (tempArray.indexOf(item) < 0) {
          //         tempArray.push(item);
          //         //console.log(tempArray,"temp")
          //       }
          //     });
          //   setTeamError(uniqueArray);
          // }
          
          if(item=="team_data"){
            //console.log("data1",data[key][item])
            //console.log(item,key,"keyyy")
            let datakey=data[key][item]
            // let uniqueArray :any =[];
            datakey.map((res:any)=>{
              //console.log(res,"res@")

              if((res.team_name=="")||(res.no_employee=="")){

                nonMandatoryFields.push("team_name");
                // uniqueArray.push(res.team_name)
                // //console.log(uniqueArray,"1432")
                errors[key].push(item);
                // setTeamError(uniqueArray)
                // error[]
                //console.log(item,"check")

              }else{
                //console.log("else")
                // uniqueArray.push(res.team_name)
                // //console.log(uniqueArray,"1432")
                // uniqueArray.push(item)
                // setTeamError(uniqueArray)
              }
              
            })
            
          }


          
         
          if (item === "quantum_fund_required_re_apply") {
            // //console.log(data[key][item]> 50000000,"1414")
            if (data[key][item] < 1 || data[key][item] > 50000000) {

              nonMandatoryFields.push("quantum_fund_required_re_apply");
              errors[key].push(item);
              //console.log("quantum")
            }
          }
          if (Array.isArray(data[key][item]) && !data[key][item].length) {
            errors[key].indexOf(item) < 0 && errors[key].push(item);
            error = true;
          } else if (!data[key][item] || !data[key][item].toString().length) {
            errors[key].indexOf(item) < 0 && errors[key].push(item);
            error = true;
          }
        }
        
      });
    });
    // setValidator(errors);
    const errorObject = { error, errors: error ? errors : null };
    return errorObject;
  };

  // Bind GeneralDetail Step 1 response
  const bindGeneralDetail = (response: any, incubator: IIncubatorModel2) => {
    ////console.log("******************************GETTING DATA FROM API *********************************", response.data.data[0]);
    setsignificantfileuploadArray(response.data.data[0].List_significant_facilities_upload)
    setfulltimeEmployeesArray(response.data.data[0].No_full_time_employees_upload);
    setPitchdeckArray(response.data.data[0].Re_apply_pitchdeck_upload);
    setPerformanceArray(response.data.data[0].Performance_Upload);
    setOtherdocArray(response.data.data[0].Other_document_upload)
    // incubator.GeneralDetail.No_individuals =
    //   response.data.data[0].No_individuals;
    // incubator.GeneralDetail.No_startups_undergoing =
    //   response.data.data[0].No_startups_undergoing;

    // incubator.GeneralDetail.List_significant_facilities =
    //   response.data.data[0].List_significant_facilities;
      

    incubator.GeneralDetail.No_startups_incubated =
      response.data.data[0].No_startups_incubated;
    incubator.GeneralDetail.No_startups_graduated =
      response.data.data[0].No_startups_graduated;
    incubator.GeneralDetail.No_startups_raised =
      response.data.data[0].No_startups_raised;
    incubator.GeneralDetail.No_startups_crossed =
      response.data.data[0].No_startups_crossed;
    incubator.GeneralDetail.survival_rate_startups =
      response.data.data[0].survival_rate_startups;
    incubator.GeneralDetail.Investment_agreements_signed =
      response.data.data[0].Investment_agreements_signed;
    incubator.GeneralDetail.No_startups_invested =
      response.data.data[0].No_startups_invested;
    incubator.GeneralDetail.allocated_incubatees =
      response.data.data[0].allocated_incubatees;
    incubator.GeneralDetail.external_sources =
      response.data.data[0].external_sources;
    incubator.GeneralDetail.No_mentors_actively =
      response.data.data[0].No_mentors_actively;
    incubator.GeneralDetail.allocated_startup_month =
      response.data.data[0].allocated_startup_month;
    incubator.GeneralDetail.No_patents_registered =
      response.data.data[0].No_patents_registered;
    incubator.GeneralDetail.No_patents_copyrights =
      response.data.data[0].No_patents_copyrights;
    incubator.GeneralDetail.No_trademarks_registered =
      response.data.data[0].No_trademarks_registered;
    incubator.GeneralDetail.Corporate_connects_facilitated =
      response.data.data[0].Corporate_connects_facilitated;
    incubator.GeneralDetail.Events_stakeholder_engagements =
      response.data.data[0].Events_stakeholder_engagements;
    incubator.GeneralDetail.Participation_Event =
      response.data.data[0].Participation_Event;
    incubator.GeneralDetail.Name_Background_current =
      response.data.data[0].Name_Background_current;

    // incubator.GeneralDetail.No_full_time_employees =
    //   response.data.data[0].No_full_time_employees;

    incubator.GeneralDetail.fulltime_employees_re_apply =
      response.data.data[0].fulltime_employees_re_apply;

    //   incubator.GeneralDetail.List_significant_facilities_upload =
    //   response.data.data[0].List_significant_facilities_upload;
    // incubator.GeneralDetail.No_full_time_employees_upload =
    //   response.data.data[0].No_full_time_employees_upload;
    // incubator.GeneralDetail.List_significant_facilities_upload_get =
    //   response.data.data[0].List_significant_facilities_upload_get;
    // incubator.GeneralDetail.No_full_time_employees_upload_get =
    //   response.data.data[0].No_full_time_employees_upload_get;

    incubator.GeneralDetail.Re_apply_pitchdeck_upload =
    response.data.data[0].Re_apply_pitchdeck_upload;
    incubator.GeneralDetail.Re_apply_pitchdeck_upload_get =
    response.data.data[0].Re_apply_pitchdeck_upload_get;

    incubator.GeneralDetail.Performance_Upload =
    response.data.data[0].Performance_Upload;
    incubator.GeneralDetail.Performance_Upload_get =
    response.data.data[0].Performance_Upload_get;

    incubator.GeneralDetail.Other_document_upload =
    response.data.data[0].Other_document_upload;
    incubator.GeneralDetail.Other_document_upload_get =
    response.data.data[0].Other_document_upload_get;

    incubator.GeneralDetail.Fund_Utilization_Details =
    response.data.data[0].Fund_Utilization_Details;

    // incubator.GeneralDetail.sum_disbured =
    // response.data.data[0].sum_disbured;

    incubator.GeneralDetail.team_data = response.data.data[0]
      .team_data.length
      ? response.data.data[0].team_data
      : [new TeamDetails(0, "", 0)];


  };

  // Bind IncubatorTeam Step 2 response
  const bindIncubatorTeam = (response: any, incubator: IIncubatorModel2) => {
    ////console.log(response.data.data[0].Details_Interest_earned, "jjjjj")
    // Details_Interest_earned
    setucfilesArray(response.data.data[0].Utilization_Certificate_Upload)
    setAuditedfilesArray(response.data.data[0].Audited_statement_expenditure_Upload)
  
    // incubator.IncubatorTeam.Utilization_Certificate_Upload =
    //   response.data.data[0].Utilization_Certificate_Upload;
    //   incubator.IncubatorTeam.Utilization_Certificate_Upload_get =
    //   response.data.data[0].Utilization_Certificate_Upload_get;
    //   incubator.IncubatorTeam.Utilization_Certificate_Upload_slice =
    //   response.data.data[0].Utilization_Certificate_Upload_slice;

    //   incubator.IncubatorTeam.Audited_statement_expenditure_Upload_get =
    //   response.data.data[0].Audited_statement_expenditure_Upload_get;
    //   incubator.IncubatorTeam.Audited_statement_expenditure_Upload_slice =
    //   response.data.data[0].Audited_statement_expenditure_Upload_slice;

    // incubator.IncubatorTeam.Details_Interest_earned =
    //   response.data.data[0].Details_Interest_earned;
    // incubator.IncubatorTeam.Grant_Disbursed =
    //   response.data.data[0].Grant_Disbursed;
    // incubator.IncubatorTeam.Debt_Disbursed_Interest_Earned =
    //   response.data.data[0].Debt_Disbursed_Interest_Earned;
    // incubator.IncubatorTeam.Audited_statement_expenditure_Upload =
    //   response.data.data[0].Audited_statement_expenditure_Upload;
    // incubator.IncubatorTeam.Debentures_Disbursed_Interest_Earned =
    // response.data.data[0].Debentures_Disbursed_Interest_Earned;
    // incubator.IncubatorTeam.Debt_Disbursed = response.data.data[0].Debt_Disbursed;

    // incubator.IncubatorTeam.Debt_Interest = response.data.data[0].Debt_Interest;

    // incubator.IncubatorTeam.Debt_Other_Earned = response.data.data[0].Debt_Other_Earned;

    // incubator.IncubatorTeam.Debentures_Disbursed = response.data.data[0].Debentures_Disbursed;

    // incubator.IncubatorTeam.Debentures_Interest_Earned = response.data.data[0].Debentures_Interest_Earned;

    // incubator.IncubatorTeam.Debentures_Other_Earned = response.data.data[0].Debentures_Other_Earned;


  };

  // Bind IncubatorDetail Step 3 response
  const bindIncubatorDetail = (response: any, incubator: IIncubatorModel2) => {
    setCurrentUploadfilesArray(response.data.data[0].Current_Incubator_Team_Upload)
    // incubator.IncubatorDetails.No_Startup_Applications_Received = response.data.data[0].No_Startup_Applications_Received;
    // incubator.IncubatorDetails.open_applications = response.data.data[0].open_applications;
    // incubator.IncubatorDetails.No_Startup_Applications_Reviewed = response.data.data[0].No_Startup_Applications_Reviewed;
    // incubator.IncubatorDetails.No_Startup_Applications_Selected = response.data.data[0].No_Startup_Applications_Selected;
    // incubator.IncubatorDetails.No_Startup_Applications_Allotted = response.data.data[0].No_Startup_Applications_Allotted;
    // incubator.IncubatorDetails.No_Startup_whom_Agreements = response.data.data[0].No_Startup_whom_Agreements;
    // incubator.IncubatorDetails.No_Startup_Applications_Cancelled = response.data.data[0].No_Startup_Applications_Cancelled;
    // incubator.IncubatorDetails.No_Startup_Applications_Closed = response.data.data[0].No_Startup_Applications_Closed;
    // incubator.IncubatorDetails.No_industries_represented = response.data.data[0].No_industries_represented;
    // incubator.IncubatorDetails.No_States_represented = response.data.data[0].No_States_represented;
    // incubator.IncubatorDetails.Number_startups_PoC_stage = response.data.data[0].Number_startups_PoC_stage;
    // incubator.IncubatorDetails.Number_startups_Prototype = response.data.data[0].Number_startups_Prototype;
    // incubator.IncubatorDetails.Number_startups_Product_Development = response.data.data[0].Number_startups_Product_Development;
    // incubator.IncubatorDetails.Number_startups_Field_Trial = response.data.data[0].Number_startups_Field_Trial;
    // incubator.IncubatorDetails.Number_startups_Market = response.data.data[0].Number_startups_Market;
    // incubator.IncubatorDetails.Number_startups_Other_Stage = response.data.data[0].Number_startups_Other_Stage;
    // incubator.IncubatorDetails.Cumulative_External_Funding = response.data.data[0].Cumulative_External_Funding;
    // incubator.IncubatorDetails.No_People_Employed_Startups = response.data.data[0].No_People_Employed_Startups;
    // incubator.IncubatorDetails.Turnover_Startups_financial = response.data.data[0].Turnover_Startups_financial;
    // incubator.IncubatorDetails.GST_Filed_Startups = response.data.data[0].GST_Filed_Startups;
    // incubator.IncubatorDetails.No_Products_Services_Startups = response.data.data[0].No_Products_Services_Startups;
    // incubator.IncubatorDetails.No_Registration_Requests_Filed = response.data.data[0].No_Registration_Requests_Filed;
    // incubator.IncubatorDetails.Grants = response.data.data[0].Grants;
    // incubator.IncubatorDetails.Convertible_Debentures = response.data.data[0].Convertible_Debentures;
    // incubator.IncubatorDetails.Debt = response.data.data[0].Debt;
    // incubator.IncubatorDetails.Debt_Linked_Instruments = response.data.data[0].Debt_Linked_Instruments;

    // incubator.IncubatorDetails.disbursed_Debt = response.data.data[0].disbursed_Debt;
    // incubator.IncubatorDetails.Funds_disbursed_Grants = response.data.data[0].Funds_disbursed_Grants;
    // incubator.IncubatorDetails.disbursed_Convertible_Debentures = response.data.data[0].disbursed_Convertible_Debentures;
    // incubator.IncubatorDetails.disbursed_Debt_Linked_Instruments = response.data.data[0].disbursed_Debt_Linked_Instruments;


    // incubator.IncubatorDetails.Total_Interest_Debt_Due = response.data.data[0].Total_Interest_Debt_Due;
    // incubator.IncubatorDetails.Total_Interest_Debt_Bank = response.data.data[0].Total_Interest_Debt_Bank;
    // incubator.IncubatorDetails.Principal_Amount_Returned = response.data.data[0].Principal_Amount_Returned;
    // incubator.IncubatorDetails.Cumulative_Monetary_Return = response.data.data[0].Cumulative_Monetary_Return;
    
    // incubator.IncubatorDetails.No_Testimonials_Success = response.data.data[0].No_Testimonials_Success;
    // incubator.IncubatorDetails.Current_Incubator_Team_Upload = response.data.data[0].Current_Incubator_Team_Upload;
    // incubator.IncubatorDetails.Current_Incubator_Team_Upload_get = response.data.data[0].Current_Incubator_Team_Upload_get;
    // incubator.IncubatorDetails.Current_Incubator_Team_Upload_slice = response.data.data[0].Current_Incubator_Team_Upload_slice;
  }
  // Bind FundDetail Step 4 response
  const bindFundDetail = (response: any, incubator: IIncubatorModel2) => {
  incubator.FundDetails.quantum_fund_required_re_apply = response.data.data[0].quantum_fund_required_re_apply;
  incubator.FundDetails.no_fund_benifitiaries_1yr_re_apply = response.data.data[0].no_fund_benifitiaries_1yr_re_apply;
  incubator.FundDetails.no_fund_benifitiaries_2yr_re_apply = response.data.data[0].no_fund_benifitiaries_2yr_re_apply;
  incubator.FundDetails.no_fund_benifitiaries_3yr_re_apply = response.data.data[0].no_fund_benifitiaries_3yr_re_apply;
  
  }

  return (
    <div>
      <IncubatorHeaderComponent />
      <div className="app-inside app-incubator">
        <div className="container-fluid about-heading app-banner-inside" id="reapply_main">
          <div>
            <div className="text-center main-heading">Incubator Reapplication</div>
            <div className="text-center sub-heading">
              All form fields are <b>mandatory</b>, unless mentioned as{" "}
              <b>‘optional’</b>
              <br />
              Application form to be filled in English language
            </div>
          </div>
        </div>
        <div className="container stepper-container">
          <div className="app-inside-content">
            <div className="row justify-content-center">
              <div className="col-xs-12 col-sm-12">
                <div id="incubatorstepper" className="bs-stepper">
                  {/* Incubator For Stepper Steps Header */}
                  <StepDetailsComponent
                    teamError={teamError}
                    errors={validator}
                    onClick={(currentStep: number) => {
                      setCurrentStep(currentStep);
                    }}
                  />

                  {/* Incubator For Stepper Steps Content */}
                  <div className="bs-stepper-content">
                    {/* Check whether to make a common reusable component for Dialog */}
                    {showIncubatorSuccessModal && (
                      // <FormSubmissionSuccess data-toggle="modal" data-target="#FormSubmissionSuccess"// />
                      <>
                        <div className="modal-backdrop fade show"></div>

                        <div
                          className="modal align-middle modal-sisfs d-block"
                          id="FormSubmissionSuccess"
                        >
                          <div className="modal-dialog modal-dialog-centered modal-md">
                            <div className="modal-content">
                              <div className="modal-body text-center">
                                <i className="fa fa-check-circle-o"></i>
                                <h3 className="modal-message">Thank You!</h3>
                                <div className="modal-text">
                                  Your application was successfully submitted.
                                  We’ll be in touch with you, soon!
                                </div>
                                <div className="modal-action">
                                  <button className="btn btn-sisfs btn-yellow-primary">
                                  {/* incubator_re_apply */}
                                    <Link to={{ pathname: "/incubator_status", state: { perform_reload: "true" } }} >Continue</Link>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {showIncubatorErrorModal && (
                      // <FormSubmissionError data-toggle="modal" data-target="#FormSubmissionError"/>
                      <>
                        <div className="modal-backdrop fade show"></div>
                        <div
                          className="modal align-middle modal-sisfs d-block"
                          id="FormSubmissionError"
                        >
                          <div className="modal-dialog modal-dialog-centered modal-md">
                            <div className="modal-content">
                              <div className="modal-body text-center">
                                <i className="fa fa-times-circle-o"></i>
                                <h3 className="modal-message">
                                  Oops! Something is Wrong
                                </h3>
                                <div className="modal-text">
                                  <ul>
                                    <li>
                                      {" "}
                                      You have either missed out on some mandatory
                                      fields{" "}
                                    </li>
                                    <li>Entered the data wrongly</li>
                                  </ul>
                                </div>
                                <div className="modal-action">
                                  <button className="btn btn-sisfs btn-yellow-primary">
                                    <Link to="/re-apply">Ok Got It!</Link>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {loader &&
                      <div className="spinner-border custom-spinner" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>}
                    <fieldset disabled={disabled}>

                      <CurrentApplicationForm
                        stepper={stepperRef}
                        onStepSave={onSave}
                        generalDetailModel={incubator.GeneralDetail}
                        applicationId={applicationId}
                        errors={validator.GeneralDetail}
                        teamError={teamError}
                      />
                      
                      {/* {console.log(validator.GeneralDetail,"1628")}; */}
                      {/* <MetricsSubsequentComponent
                        stepper={stepperRef}
                        onStepSave={onSave}
                        incubatorTeamDetailsModel={incubator.IncubatorTeam}
                        errors={validator.IncubatorTeam}
                        teamError={teamError}
                      /> */}
                      {/* {//console.log(validator.IncubatorTeam,"1679")} */}
                      {/* <MetricIncubatorComponent
                        stepper={stepperRef}
                        onStepSave={onSave}
                        incubatorDetailsModel={incubator.IncubatorDetails}
                        applicationId={applicationId}
                        errors={validator.IncubatorDetails}
                      /> */}
                      {/* {////console.log(validator.IncubatorDetails)}; */}
                      
                      <FundRequiremntDtls
                      stepper={stepperRef}
                      onStepSave={onSave}
                      fundDetailsModel={incubator.FundDetails}
                      errors={validator.FundDetails}
                      disabled={disabled}
                      applicationId={applicationId}
                      // teamError={teamError}
                    />
                    {/* {//console.log(validator.FundDetails,"FundDetails")} */}
                    </fieldset>

                    {stopSubmit && (
                      <ConfirmationDialog
                        headerText=""
                        bodyText="Only Incubators not disbursing seed fund to incubatees using
                    funding from any third-party private entity are eligible"
                        onDialogClose={() => setStopSubmit(false)}
                        iconClass="fa fa-times-circle-o"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReApplyIncComponent;
